import { render, staticRenderFns } from "./CollectionDataTable.vue?vue&type=template&id=ec8ea3cc&scoped=true&"
import script from "./CollectionDataTable.vue?vue&type=script&lang=js&"
export * from "./CollectionDataTable.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDataTable.vue?vue&type=style&index=0&id=ec8ea3cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8ea3cc",
  null
  
)

export default component.exports